import React from 'react';

const QuotesRight = (props) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 1200 1200"
      fill="#000"
      {...props}
    >
      <switch>
        <g>
          <path
            fill="currentFill"
            d="M681.526 1094.657c212.643-14.942 518.306-48.892 518.474-465.344v-523.97H725.496v560.61h157.559c9.98 149.693-113.285 188.346-247.329 218.017l45.8 210.687zm-635.724 0c212.644-14.942 518.307-48.894 518.474-465.344v-523.97H89.77v560.61h157.559C257.311 815.647 134.044 854.3 0 883.971l45.802 210.686z"
          />
        </g>
      </switch>
    </svg>
  );
};

export default QuotesRight;
